import { useState } from "react";

interface PaginationProps {
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (currentPage: number) => void;
}

export const Pagination = ({ totalItems, itemsPerPage, onPageChange }: PaginationProps) => {
  // State cho phân trang
  const [currentPage, setCurrentPage] = useState(1);

  // Tính toán tổng số trang
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Hàm chuyển trang
  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return; // Kiểm tra giới hạn trang
    setCurrentPage(page);
    onPageChange(page); // Gọi callback để thông báo trang hiện tại
  };

  return (
    <div className="mb-4 d-flex justify-content-center align-items-center gap-2">
      {/* Nút mũi tên trái */}
      <button
        className="btn btn-light"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1} // Vô hiệu hóa nếu đang ở trang đầu
      >
        &lt;
      </button>

      {/* Các nút số trang */}
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index}
          className={`btn ${currentPage === index + 1 ? 'btn-primary' : 'btn-light'}`}
          onClick={() => handlePageChange(index + 1)}
        >
          {index + 1}
        </button>
      ))}

      {/* Nút mũi tên phải */}
      <button
        className="btn btn-light"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages} // Vô hiệu hóa nếu đang ở trang cuối
      >
        &gt;
      </button>
    </div>
  );
};